import { createDefaultMonitorEventFilters } from '../utils/events'

export const companySettings = {
    account: '',
    status: 'ACTIVE',
    monitor: {
        eventFilters: createDefaultMonitorEventFilters(),
        callRecordingEnabled: false,
    },
}
